import { customElement, property } from 'lit/decorators.js';
import { SuperElement } from '../../../internals/super/SuperElement';
import { html } from 'lit';
import '../../icon/icons/IconStarFilled';
import { type LrIconSize } from '../../icon/Icon.component';
import { ratingElementStyles } from './RatingElement.styles';

@customElement('lr-rating-element')
export class RatingElement extends SuperElement {
    @property({ type: Boolean, reflect: true })
    active = false;

    @property({ type: String, reflect: true })
    size: LrIconSize = 'medium';

    static styles = [SuperElement.styles, ratingElementStyles];

    renderElement() {
        return html`<lr-icon-star-filled size=${this.size}></lr-icon-star-filled>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'lr-rating-element': RatingElement;
    }
}
